import { authApi } from '../api/authApi';
import { connectionClient, devicePlatform } from '../utils/deviceUtils';

// Fire-and-forget from every client, inside the session check: nothing may escape it.
export const recordConnection = (): void => {
  try {
    authApi.createConnection({ client: connectionClient(), platform: devicePlatform() }).catch(() => {});
  } catch {
    // ponytail: a broken detection must never log the user out
  }
};
